var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYogaIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 95.335938 291.332031 C 133.460938 291.332031 167.660156 308.449219 190.664062 335.398438 L 190.664062 95.332031 C 190.664062 42.765625 147.898438 0 95.335938 0 C 42.765625 0 0 42.765625 0 95.332031 L 0 335.398438 C 23.007812 308.449219 57.207031 291.332031 95.335938 291.332031 Z M 95.335938 291.332031 ",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.835938 80.332031 L 219.765625 80.332031 C 220.355469 85.253906 220.664062 90.257812 220.664062 95.332031 L 220.664062 416.664062 C 220.664062 454.792969 203.546875 488.992188 176.601562 512 L 456.835938 512 C 487.253906 512 512 487.253906 512 456.832031 L 512 135.5 C 512 105.082031 487.253906 80.332031 456.835938 80.332031 Z M 456.835938 80.332031 ",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95.335938 321.332031 C 42.765625 321.332031 0 364.101562 0 416.664062 C 0 469.234375 42.765625 512 95.335938 512 C 147.898438 512 190.664062 469.234375 190.664062 416.664062 C 190.664062 364.101562 147.898438 321.332031 95.335938 321.332031 Z M 95.335938 321.332031 ",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaIconWhite);
export default __webpack_public_path__ + "static/media/yoga_icon_white.26b51e0b1c7f4c4dbd036fabd330de18.svg";
export { ForwardRef as ReactComponent };